// SSH
export default {
  device_terminal_connect_closed: 'Connection closed',
  device_terminal_connect_failed: 'Connection failed',
  device_terminal_params_error: 'Parameter error, please pass the correct parameter',
  device_terminal_connect_retry: 'Reconnect',
  device_terminal_userName: 'Username',
  device_terminal_userName_placeholder: 'Please enter the user name',
  device_terminal_userName_required: 'User name cannot be empty',
  device_terminal_password: 'Password',
  device_terminal_password_placeholder: 'Please enter your password',
  device_terminal_password_required: 'Password cannot be empty',
  device_terminal_port: 'Port',
  device_terminal_port_placeholder: 'Please enter the port',
  device_terminal_port_required: 'The port cannot be empty',
};
